<template lang="html">
  <div v-if="user"   class="container">
      <h4 class="center light-blue-text">Editer les informations de {{ user.alias }}</h4>
      <form @submit.prevent="editUser">
<code>{{user}}</code>
          <div class="field">
              <label for="alias">Nom d'utilisateur:</label>
              <input type="text" name="alias" v-model="user.alias">
          </div>
          <div class="field">
              <label for="last_name">Nom:</label>
              <input type="text" name="last_name" v-model="user.last_name">
          </div>
          <div class="field">
              <label for="first_name">Prénom:</label>
              <input type="text" name="first_name" v-model="user.first_name">
          </div>
          <div class="field">
              <label for="service">Service:</label>
              <input type="text" name="service" v-model="user.service">
          </div>
          <div class="field">
              <label for="phone">Téléphone:</label>
              <input type="text" name="phone" v-model="user.phone">
          </div>
          <div>
              
             <button v-if="(user.active == true)" @click.prevent="statusChange()" class="btn red">Désactiver cet utilisateur</button>
             <button v-else @click.prevent="statusChange()" class="btn light-green">Réactiver cet utilisateur</button>
          </div>
          <p class="red-text center" v-if="feedback">{{feedback}}</p>
          <div class="input-field right">
              <button class="btn red">Annuler</button>
              &nbsp
              <button class="btn light-blue">Valider</button>
          </div>
      </form>
  </div>
</template>

<script>
import db from '@/firebase/init'
import slugify from 'slugify'

export default {
    name: 'EditUser',
    data(){
        return{
            user: null,
            feedback: null

        }
    },
    methods: {
        statusChange(){
            this.user.active = !this.user.active
            console.log(this.user.active)
        },
        editUser(){
            if(this.user.alias){
                this.feedback = null 
                }
                db.collection('users').doc(this.user.id).update({
                    alias: this.user.alias,
                    last_name: this.user.last_name,
                    first_name: this.user.first_name,
                    service: this.user.service,
                    phone: this.user.phone,
                    active:this.user.active
                    // mobile: this.user.mobile
                }).then (() => {
                    this.$router.push({name: 'EditUsers'})
                }).catch(err => {
                    console.log(err)
                })
            }
        },
        created(){
            let ref = db.collection('users').where('slug', '==', this.$route.params.user_slug)
            ref.get().then(snapshot => {
                snapshot.forEach(doc => {
                    this.user = doc.data()
                    this.user.id= doc.id
                    }
                )
            })
        }
}
</script>

<style lang="css" scoped>

h4{
    margin-top: 70px;
}

</style>
